<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Have you EVER experienced a heart attack (MI – myocardial infarction) or silent heart attack? <br /> 
      <i>(Check all that apply)</i>
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.heartAttacks">
      <b-form-checkbox v-model="survey.arteryBlockages.heartAttacks.hadNoHeartAttack"
                       @change="onNoHeartAttackSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.heartAttacks.hadMI"
                       @change="onMiSelected">
        Heart attack (MI – myocardial infarction)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.heartAttacks.hadSilentHA"
                       @change="onSilentHaSelected">
        Silent heart attack
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      heartAttacks: {
        anyOptionRequired: anyOptionRequired((value) => value.hadNoHeartAttack || value.hadMI
          || value.hadSilentHA)
      }
    },

    computed: {
      ...mapState(["survey"]),

      heartAttacks() { return this.survey.arteryBlockages.heartAttacks; }
    },

    methods: {
      onNoHeartAttackSelected(value) {
        this.setOptions(value, false, false);
      },

      onMiSelected(value) {
        this.setOptions(false, value, this.heartAttacks.hadSilentHA);
      },

      onSilentHaSelected(value) {
        this.setOptions(false, this.heartAttacks.hadMI, value);
      },

      setOptions(hadNoHeartAttack, hadMI, hadSilentHA) {
        this.survey.arteryBlockages.heartAttacks.hadNoHeartAttack = hadNoHeartAttack;
        this.survey.arteryBlockages.heartAttacks.hadMI = hadMI;
        this.survey.arteryBlockages.heartAttacks.hadSilentHA = hadSilentHA;
      }
    }
  };
</script>